import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AdminDictionaryProductAttributeApiService } from '../api/services/admin-dictionary-product-attribute-api.service';
import { Guid } from '@web/utils';

@Injectable({
  providedIn: 'root',
})
export class AdminDictionaryProductAttributeSelectItemsProviderService {
  /* prettier-ignore */
  private readonly adminDictionaryApi = inject(AdminDictionaryProductAttributeApiService);

  public fetchLabelFor(id: Guid, cache = false): Observable<string> {
    return this.adminDictionaryApi
      .fetchDetailsById(id, cache)
      .pipe(map(({ label }) => label));
  }
}
